import type { Permission } from '@myrentalmate/api-client';

import { useMe } from './me';

/** For hiding buttons only. The API enforces permissions on every route. */
export function useCan(permission: Permission): boolean {
  const { data: me } = useMe();
  return me?.permissions.includes(permission) ?? false;
}
